import cleverTapAnalytics from "@services/analytics";
import { InvokeType, shareOnWhatsapp } from "@utils/shareEntity";
import useGetCXAppLink from "@utils/useGetCXAppLink";
import { SHARING_EVENTS } from "@constants/analyticsEventsCT";
import { getLeaderBcard } from "@services/api";
import useLeaderState from "./useLeaderState";

const useShopShare = () => {
  const message = useGetCXAppLink();

  const { canLeaderUseApp, canShareShop } = useLeaderState();
  const handleShopShare = () => {
    if (!canLeaderUseApp()) {
      return;
    }
    if (!canShareShop()) {
      return;
    }
    cleverTapAnalytics.trackEvent(SHARING_EVENTS.SHOP_SHARE);

    try {
      getLeaderBcard().then((response) => {
        if (response.status === 200) {
          const bCardUrl = response?.data?.transparent_url;
          message &&
            shareOnWhatsapp({
              message,
              image: bCardUrl,
              invoke: InvokeType.both,
            });
        } else {
          message && shareOnWhatsapp({ message });
        }
      });
    } catch (e) {
      message && shareOnWhatsapp({ message });
    }
  };
  return [handleShopShare];
};

export default useShopShare;
